export default __webpack_public_path__ + "static/media/cm-logo-edit.0d7bb837.png";